import $ from 'jquery';

function init() {
  $.fn.toggleText = function(t1, t2) {
    if (this.text() == t1) this.text(t2);
    else                   this.text(t1);
    return this;
  };

  $('.readmore-block').each(function () {
    $(this).click(function (e) {
      e.preventDefault();
      const countButtons = $(this).closest('.content-col__inside').find('.readmore-block').length;

      if ($(window).width() > 992) {
        $(this).prev().slideToggle();
        $(this).find('span').toggleText('Weniger lesen', 'Weiter lesen...');
        $(this).closest('.content-section').find('.img-container .content-col__inside p').slideToggle()
      } else {
        if (countButtons >= 2) {
          $(this).closest('.content-col__inside').find('.read-more--normal .readmore-block-container').slideToggle();
          $(this).closest('.content-col__inside').find('.read-more--mobile .readmore-block-container').slideToggle();

          $(this).closest('.content-col__inside').find('.readmore-block').each(function () {
            $(this).find('span').toggleText('Weniger lesen', 'Weiter lesen...');
          });
        } else {
          $(this).find('span').toggleText('Weniger lesen', 'Weiter lesen...');
          $(this).closest('.content-col__inside').find('.readmore-block-container').slideToggle();
        }
      }

      $(this).closest('.content-section').toggleClass('content-section--read-more');
      $(this).closest('.content-col__inside').find('.readmore-block').toggleClass('readmore-block--is-visible');
    });

    const countButtons = $(this).closest('.content-col__inside').find('.readmore-block').length;
    if (countButtons === 1) {
      if ( $(this).closest('.read-more').hasClass('read-more--normal')) {
        $(this).closest('.read-more').find('.readmore-block').addClass('d-block')
      }

      if ( $(this).closest('.read-more').hasClass('read-more--mobile')) {
        $(this).closest('.read-more').find('.readmore-block').addClass('d-block d-lg-none')
      }
    } else {
      $(this).closest('.content-col__inside').find(`.read-more .readmore-block`).addClass('hide-on-mobile');
      $(this).closest('.content-col__inside').find(`.read-more:nth-of-type(${countButtons}) .readmore-block`).addClass('d-block');
      $(this).closest('.content-col__inside').find(`.read-more:nth-of-type(${countButtons}) .readmore-block`).removeClass('hide-on-mobile');
    }

  });
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
